<template>    
<div class="experitses">

    <NavbarApp />
    <Expertise/>
    <Section4/>
</div>

</template>

<script>
import NavbarApp from '../components/HomePage/navbar-law.vue'
import Section4 from '../components/HomePage/section-4.vue'
import Expertise from '../components/Expertise/expertise-component.vue'
export default {
  name: 'ExpertisesPage',
  components: {
    NavbarApp,
    Section4,
    Expertise,
  }
}


</script>


<style scoped>



</style>